import React from "react"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { GLAccountTypes, validateTextState, VALIDATION_TYPE } from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CloseableProcessesStatus from "../../fragments/CloseableProcessesStatus"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import SimpleForm from "../../fragments/SimpleForm"

class AccountingSetting extends React.Component {

  state = {
    running: false,
    success: false,
    error: null,
    accountType: '',
    showStatus: false,
    accountTypeValidationState: VALIDATION_TYPE.NULL,
  }

  componentDidMount() {
    this.loadConfig()
  }

  loadConfig = () => blockingFetchService(
    accessToken => apiServerApi.getRepaymentAccountType(accessToken),
    accountType => this.setState({ accountType }),
    error => this.setState({ error: error.text }),
    _ => {}
  )

  accountTypeChanged = accountType => this.setState({
    accountType,
    accountTypeValidationState: validateTextState(accountType, false),
    error: null
  })

  saveConfig = () => {

    const { accountType } = this.state
    this.setState({
      showStatus: true,
      success: false,
      error: null
    })

    if(!accountType) {
      this.setState({ error: "Please select an item!" })
      return
    }

    this.setState({ running: true })
    blockingFetchService(
      accessToken => apiServerApi.saveRepaymentAccountType(accessToken, accountType),
      _ => this.setState({ success: true }),
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderContent = () => {
    const { accountType, running, success, error, accountTypeValidationState, showStatus } = this.state
    return (
      <SimpleForm onSave={ this.saveConfig } running={ running }>

        <CloseableProcessesStatus
          error={ error }
          running={ running }
          success={ success }
          close={ !showStatus }
          handleClose={() => this.setState({ showStatus: false })}
        />

        <FormControlInlineSelect
          controlId='accountType' validationState={ accountTypeValidationState }
          label='Repayment Account Type' value={ accountType }
          onChange={ this.accountTypeChanged }
          options={ GLAccountTypes }
          helpText='Type of GL accounts that are used on the repayment form.'
          withEmptyOption={ true }
          disabled={ running }
        />
      </SimpleForm>
    )
  }

  render() {
    return <div>
      <CustomBreadCrumb activeText='Accounting' data={[{ url: '/settings', title: 'Settings' }]} />
      { this.renderContent() }
    </div>
  }
}

export default AccountingSetting



// WEBPACK FOOTER //
// ./src/components/Settings/AccountingSetting/index.js